import "./TrustedInspectionsServiceAndLocationPages.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import OurLocations from "./sections/OurLocations";
import PageTemplateDetails from "./sections/PageTemplateDetails";
import Footer from "@/reusable_sections/Footer";
export default function TrustedInspectionsServiceAndLocationPagesPage() {
  return <div>
      <Header />
      <OurServices />
      <OurLocations />
      <PageTemplateDetails />
      <Footer />
    </div>;
}